export default __webpack_public_path__ + "static/media/rose.74b6fb77.svg";